import {TypeConstant} from './TypeConstant';

const initStat = {
	image: `${process.env.PUBLIC_URL}/ksu-identity.png`,
	showAiYearLogo: false,
};

const imageReducer = (state = initStat, action) => {
	if (action.type === TypeConstant.Image) {
		return {...state, image: action.payload};
	}
	if (action.type === TypeConstant.ShowAiYearLogo) {
		return {...state, showAiYearLogo: action.payload};
	}
	return state;
};

export default imageReducer;
